import { formatDate, DateFormat } from '@/helpers/dateHelper';
import calendar from '@/shared/icons/calendar/calendar.vue';
import cancel from '@/shared/icons/cancel/cancel.vue';
import DatePicker from 'vuejs-datepicker';

// Typing for this object is from https://github.com/charliekassel/vuejs-datepicker#disabled-dates
export interface DisabledDateObject {
  to?: Date;
  from?: Date;
}

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'singleDatePicker',
  components: {
    datePicker: DatePicker,
    calendar,
    cancel,
  },
  props: {
    value: {
      type: Date,
    },
    placeholder: {
      type: String,
    },
    enabledDates: {
      type: Array as () => string[],
    },
    disabledDates: {
      type: Object as () => DisabledDateObject,
      default() {
        return { to: new Date() };
      },
    },
  },
  methods: {
    clearDate() {
      this.$emit('clearDate');
    },
    openCalendar(): void {
      document.getElementById('date-picker')?.click();
    },
    dateFormatter(date: Date): string {
      return formatDate(date, DateFormat.DateWithOrdinal).toUpperCase();
    },
  },
});
